<template>
  <div class="register">
    <div class="register-header">
      <div class="header">
        <div class="register-top clearfix">
          <div class="reg left">
            <div class="regtitle">
              <p>阿科索科技</p>
            </div>
          </div>
          <div class="reg right">
            <div class="reglogin" @click="dolog">
              <p><Icon type="log-in" color="#2d8cf0"></Icon>&nbsp;&nbsp;登录</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="register-con">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
    export default {
        name: "reg",
      data () {
        return {

        }
      },
      methods: {
        doreg (val) {
          console.log(val);
        },
        dolog () {
          this.$router.push({
            path:'/',
          })
        }
      }
    }
</script>

<style lang="less" scoped>
  .register{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
    min-width: 1028px;
    &-header {
      width:100%;
      height:80px;
      box-shadow: 0 2px 1px 1px rgba(100,100,100,.1);
    }
    .header{
      width:80%;
      height:80px;
      margin:0 10%;
    }
    &-top {
      height:80px;
      line-height:80px;
      .reg{
        height:80px;
      }
      .reglogin p{
        font-size:16px;
        display:inline-block;
        color:#2a86af;
        cursor: pointer;
      }
      .regtitle p:before {
        width:77px;
        display:inline-block;
        content:'';
        vertical-align: middle;
        height:45px;
        background: transparent url(../../assets/logo-min.jpg) no-repeat;
        background-size:68px 40px;
      }
      .regtitle{
        font-size:24px;
        font-weight:normal;
        display:inline-block;
      }
    }
    &-con {
      width:100%;
      height:auto;
      margin-top:10px;
      background:#fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/register/reg.vue